import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { DualViewRefModel } from '../model/dual-view-ref.model';
import { Emitter, type Event } from '@patsnap/tahiti-core/common/event';
import type { SupportedSide, DualViewRefItem, DualViewRef } from '../type/dual-view.type'

export const DualViewRefService = Symbol('DualViewRefService');

export interface DualViewRefService {
    readonly onStatesChange: Event<DualViewRef>;
    
    leftRef: DualViewRefItem;
    rightRef: DualViewRefItem;

    getModelData(): DualViewRef;
    updateRefBySide(target: { side: SupportedSide, ref: DualViewRefItem }): void;
    clearRefBySide(target: { side: SupportedSide }): void;
}

@injectable()
export class DualViewRefServiceImpl implements DualViewRefService {
    private _onStatesChangeEmitter = new Emitter<DualViewRef>();
    readonly onStatesChange = this._onStatesChangeEmitter.event;

    constructor(
        @inject(DualViewRefModel)
        private _model: DualViewRefModel,
    ) {
        this._model.onStatesChange(this._emitModelDataChange.bind(this));
    }

    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.getModelData());
    }

    public getModelData() {
        return this._model.modelData;
    }

    public get leftRef() {
        return this.getModelData().left;
    }

    public get rightRef() {
        return this.getModelData().right;
    }

    public updateRefBySide(target: { side: SupportedSide, ref: DualViewRefItem }) {
        const data = this.getModelData();
        data[target.side] = target.ref;
        this._model.update(() => data);
    }

    public clearRefBySide(target: { side: SupportedSide }) {
        const data = this.getModelData();
        data[target.side] = null;
        this._model.update(() => data);
    }
}
